import React from 'react';
import { useNavigate } from 'react-router-dom';
import PlayerSetup from '../components/PlayerSetup';

interface PlayersProps {
  players: string[];
  onAddPlayer: (name: string) => boolean;
  onRemovePlayer: (index: number) => void;
  canAddMore: boolean;
  hasEnoughPlayers: boolean;
}

export default function Players({
  players,
  onAddPlayer,
  onRemovePlayer,
  canAddMore,
  hasEnoughPlayers,
}: PlayersProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-[#0d1117] to-black flex flex-col p-6 page-enter safe-top safe-bottom safe-x">
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
        <button
          onClick={() => navigate('/')}
          className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/60 btn-press"
        >
          ←
        </button>
        <div>
          <h1 className="font-display font-bold text-2xl text-white">Joueurs</h1>
          <p className="font-body text-white/40 text-sm">Qui est dans la partie ?</p>
        </div>
      </div>

      {/* Player setup */}
      <div className="flex-1">
        <PlayerSetup
          players={players}
          onAddPlayer={onAddPlayer}
          onRemovePlayer={onRemovePlayer}
          canAddMore={canAddMore}
        />
      </div>

      {/* Play button */}
      <div className="mt-6 pb-4">
        <button
          onClick={() => navigate('/select')}
          disabled={!hasEnoughPlayers}
          className="w-full py-4 rounded-2xl bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white font-display font-bold text-lg btn-press disabled:opacity-30 disabled:cursor-not-allowed transition-opacity shadow-[0_4px_30px_rgba(124,58,237,0.3)]"
        >
          {hasEnoughPlayers ? 'Jouer ! 🎮' : `Encore ${2 - players.length} joueur${2 - players.length > 1 ? 's' : ''}`}
        </button>
      </div>
    </div>
  );
}
